import useInViewport from '../hooks/useInViewport';

const InViewportWrapper = ({ children, options }) => {
  const [ref, isInView] = useInViewport(options);

  return children({ ref, isInView });
};

export default InViewportWrapper;
